// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import AnchorMenu, { AnchorMenuStyles } from "@store/Library/Components/Toolkit/Anchor/AnchorMenu";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
}

type Props = WidgetProps & {
    fields: {
        [fields.blockFullWidth]: boolean;
        [fields.blockVariant]: string;
        [fields.blockVariantSide]: string;
        [fields.blockMargin]: string;
    };
};

export interface ProductDetailsAnchorMenuStyles {
    anchorMenu?: AnchorMenuStyles;
    block?: BlockProps;
}

export const productDetailsAnchorMenuStyles: ProductDetailsAnchorMenuStyles = {
    block: {
        spacerCss: css`
            ${breakpoint("sm", "down")} {
                &::before {
                    content: "";
                    display: block;
                    height: ${pxToRem(1)};
                    background-color: ${getColor("common.border")};
                }
            }
        `,
        wrapperCss: css`
            ${breakpoint("sm", "down")} {
                display: none;
            }
        `,
    },
    anchorMenu: {
        wrapper: {
            css: css`
                ${clearfixStyles()}
                display: flex;
                background-color: ${getColor("common.accent")}; /* Store Custom Code */
                min-height: ${pxToRem(56)};
                padding: ${pxToRem(17, 32)};
            `,
        },
        list: {
            css: css`
                display: flex;
                flex-flow: row wrap;
                justify-content: space-evenly; /* Store Custom Code */
                flex-grow: 1;
                margin: ${pxToRem(-10, 0, 0, -32)};
            `,
        },
        listItem: {
            css: css`
                display: flex;
                margin: ${pxToRem(10, 0, 0, 32)}; /* Store Custom Code */
            `,
        },
        link: {
            css: css`
                ${linkAltStyles()}
                text-align: center;

                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.base};
                    font-weight: ${theme.design.typography.weight.bold}; /* Store Custom Code */
                    line-height: ${theme.design.typography.lineHeight.semi};
                `}
            `,
        },
    },
};

const styles = productDetailsAnchorMenuStyles;

const AnchorMenuWidget: FC<Props> = ({ fields: { blockFullWidth, blockVariant, blockVariantSide, blockMargin } }) => {
    return (
        <Block
            fullWidth={blockFullWidth}
            variant={blockVariant}
            variantSide={blockVariantSide}
            margin={blockMargin}
            {...styles.block}
        >
            <AnchorMenu extendedStyles={styles.anchorMenu} />
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: AnchorMenuWidget,
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        icon: "arrow-down-from-line",
        fieldDefinitions: [
            {
                ...blockVariantField,
                name: fields.blockVariant,
                sortOrder: 100,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                sortOrder: 101,
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                sortOrder: 103,
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                sortOrder: 104,
            },
        ],
    },
};

export default widgetModule;
